/**
 * @author alteredq / http://alteredqualia.com/
 * @author davidedc / http://www.sketchpatch.net/
 *
 * NVIDIA FXAA by Timothy Lottes
 * http://timothylottes.blogspot.com/2011/06/fxaa3-source-released.html
 * - WebGL port by @supereggbert
 * http://www.glge.org/demos/fxaa/
 */
import { Vector2 } from 'three';
import vertexShader from './fxaaVertex.glsl';
import fragmentShader from './fxaaFragment.glsl';

export const CustomFXAAShader = {
  uniforms: {
    tDiffuse: { value: null },
    exposure: { value: 2.0 },
    resolution: { value: new Vector2(1 / 1024, 1 / 512) },
  },

  vertexShader,
  fragmentShader,
};
